import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from "react";
import { KANBAN_COL_GUTTER } from "~/components/KanbanView/shared/kanbanConstants";
/** This component puts left/right margins on the column consistently, so that columns
 * appear the same in react-window as well as null state
 */ const _KanbanColumnSpacingWrapper = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { style, ...props } = param;
    return /*#__PURE__*/ _jsx("div", {
        ref: ref,
        style: {
            paddingLeft: KANBAN_COL_GUTTER / 2,
            paddingRight: KANBAN_COL_GUTTER / 2,
            ...style
        },
        ...props
    });
});
_KanbanColumnSpacingWrapper.displayName = "_KanbanColumnSpacingWrapper";
export const KanbanColumnSpacingWrapper = /*#__PURE__*/ memo(_KanbanColumnSpacingWrapper);
KanbanColumnSpacingWrapper.displayName = "KanbanColumnSpacingWrapper";
